import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button, useMediaQuery } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import VerificationInput from "./VerificationPinInput";
import { enqueueSnackbar } from "notistack";
import {
  otp_verification_api,
  forgot_password_api,
} from "../../DAL/auth/login";

export default function OtpScreen() {
  const [otp, setOtp] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [timer, setTimer] = useState(60);
  const [canResend, setCanResend] = useState(false);

  const email = location?.state?.email;

  const handleOtpComplete = (enteredOtp) => {
    setOtp(enteredOtp);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (otp.length === 6) {
      console.log("Navigating to Confirm Password...");
    } else {
      enqueueSnackbar("Please enter 6-digit OTP.", {
        variant: "error",
      });
      return;
    }
    setLoading(true);

    const otp_post_data = {
      email: email,
      verification_code: otp,
    };
    const response = await otp_verification_api(otp_post_data);
    if (response.code === 200) {
      enqueueSnackbar(response.message, { variant: "success" });
      navigate("/confirm-password", {
        state: { email: email },
      });
      setLoading(false);
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
      setLoading(false);
    }
  };
  const handleResend = async () => {
    setCanResend(false);
    setTimer(60);
    const resendData = { email };
    const response = await forgot_password_api(resendData);
    console.log(response, "responseresponseresponse");
    if (response.code === 200) {
      enqueueSnackbar("OTP resent successfully", { variant: "success" });
    } else {
      enqueueSnackbar("Failed to resend OTP", { variant: "error" });
    }
  };

  useEffect(() => {
    let interval = null;
    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else {
      setCanResend(true);
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [timer]);

  return (
    <div className="container login_page">
      <div className="mt-4">
        <div
          style={{
            marginTop: "90px",
            marginRight: "40px !important",
            paddingLeft: "0px",
          }}
        >
          <Link
            style={{
              color: "#fff",
              textDecoration: "none",
              marginRight: "45px",
              fontWeight: "normal",
            }}
            to={"/login"}
          >
            <ArrowBack sx={{ marginRight: "5px" }} className="arrow-mui" />
            Back To Login? Login
          </Link>
        </div>
      </div>

      <div className="row justify-content-center">
        <div className="col-12 col-md-4 login-box mt-4">
          <h2 className="login-title">Password Reset</h2>
          <p className="login-subtitle">
            We sent a 6-digit password code to your email. Enter the code to
            proceed.
          </p>
          <VerificationInput onInputFilled={handleOtpComplete} />
          <button
            fullWidth
            className="large-button-contained mt-4"
            variant="contained"
            color="primary"
            sx={{ marginTop: "15px" }}
            onClick={handleSubmit}
          >
            {loading ? "Continuing..." : "Continue"}
          </button>{" "}
          <p className="text-center mt-2 color-white">
            {canResend ? (
              <span
                onClick={handleResend}
                style={{
                  cursor: "pointer",
                  fontWeight: "500",
                }}
              >
                Didn’t receive the code? Click to Resend.
              </span>
            ) : (
              `You can resend code in ${timer}s`
            )}
          </p>
        </div>
      </div>
    </div>
  );
}
